var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ProjectsDocumentsFilteredList", {
    attrs: {
      companyId: _vm.company.id,
      currentUser: _vm.currentUser,
      projectDetailsRouteName: _vm.RouteNames.PROJECT_ACTIVITY,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }